export default __webpack_public_path__ + "static/media/ill_header.e0728412.png";